module.exports = __webpack_public_path__ + "img/language.7d60bc4e.svg";